module.exports = __webpack_public_path__ + "img/logo_dom-white.60c78030.svg";